import React  from 'react';
import HeadTittle from '../../../../components/HeadTittle';
import routes from '../../../../Routes/routes';
import {
    AddIcon,
    IconCanceledByVisitorCard,
    ConnectIcon,
    BanSolidIcon,
    SettingIcon
} from '../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import DivContainerBody from '../../../../components/DivContainerBody';
import FieldsController from './FieldsController';
import UpdateControllerApp from "./Functionality/UpdateControllerApp";
import FormatTable from "./SubComponents/FormatTable";
import InputTable from "./SubComponents/InputTable";
import SiosTable from "./SubComponents/SiosTable";
import ReaderTable from "./SubComponents/ReaderTable";
import {permissionObj} from "../../../../Helpers/permission";
import CommonControllerApp from "./Functionality/CommonControllerApp";
import OutputTable from "./SubComponents/OutputTable";
import AcrTable from "./SubComponents/AcrTable";
import { handleConnect, handleReset, handleSetConfig } from './Model/Models';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const UpdateController = () => {
    const props = CommonControllerApp();

    const {
        controller,
        handleChange,
        emptyFields,
        getListStatus,
        isValidIp,
        isValidOffset
    } = props;

    const {
        DEV,
        permission,
        handleUpdate,
        defaultSioList,
        defaultFormatList,
        dispatch, 
        id
    } = UpdateControllerApp(props);

    return (
        <>
            <HeadTittle name={'update'} link={routes.controller.list} >
                <ButtonAction
                    id='btn_up_connect'
                    name='connect'
                    className='btn-icon-add'
                    Icon={ConnectIcon}
                    onClick={() => handleConnect(dispatch, id)}
                />
                <ButtonAction
                    id='btn_up_set_config'
                    name='set_config'
                    className='btn-icon-reset-config'
                    splitName={false}
                    Icon={SettingIcon}
                    onClick={() => handleSetConfig(dispatch, id)}
                />
                <ButtonAction
                    id='btn_up_reset'
                    name={"reset"}
                    className='btn-icon-delete'
                    Icon={IconCanceledByVisitorCard}
                    onClick={() => handleReset(dispatch, id)}
                />

                {(DEV || permission?.includes(permissionObj?.WEB_HID_UPDATE)) && (
                    <ButtonAction
                        id='btn_uc_update'
                        name='update'
                        className='btn-icon-edit'
                        Icon={AddIcon}
                        onClick={() => {
                            handleUpdate();
                        }}
                    />
                )}
            </HeadTittle>
            <DivContainerBody>
                <div className='row mt-4'>
                    <FieldsController
                        controller={controller}
                        handleChange={handleChange}
                        emptyFields={emptyFields}
                        allStatus={getListStatus}
                        isValidIp={isValidIp}
                        isValidOffset={isValidOffset}
                    />
                </div>
                <FormatTable defaultFormatList={defaultFormatList}/>
                <SiosTable defaultSioList={defaultSioList}/>
                <ReaderTable defaultSioList={defaultSioList}/>
                <InputTable defaultSioList={defaultSioList}/>
                <OutputTable defaultSioList={defaultSioList}/>
                <AcrTable defaultSioList={defaultSioList}/>
            </DivContainerBody>
        </>
    );
};

export default UpdateController;
